export interface SocialPage {
  id: string;
  name: string;
  picture?: string | null;
}

export type PageChoiceSection = 'hidden' | 'choose' | 'chosen';

/**
 * UI-staat van de Facebook-paginakeuze.
 * - 'hidden': niet gekoppeld, of 0/1 pagina (auto-select in deliverPost dekt 1).
 * - 'choose': meerdere paginas, nog geen keuze gezet.
 * - 'chosen': meerdere paginas, keuze gezet.
 */
export function facebookPageSection(
  connected: boolean,
  pageCount: number,
  currentPageId: string | null,
): PageChoiceSection {
  if (!connected || pageCount <= 1) return 'hidden';
  return currentPageId ? 'chosen' : 'choose';
}

/**
 * UI-staat van de LinkedIn-paginakeuze. Geen 'chosen'-staat: de dropdown
 * blijft staan omdat "Persoonlijk profiel" altijd een geldige optie is.
 * Zichtbaar vanaf één bedrijfspagina.
 */
export function linkedinPageSection(
  connected: boolean,
  pageCount: number,
): Extract<PageChoiceSection, 'hidden' | 'choose'> {
  if (!connected || pageCount < 1) return 'hidden';
  return 'choose';
}

/**
 * Blokkade-melding voor de inplan-dialoog: alleen "niet gekoppeld".
 * De doelkeuze (welke pagina) wordt sinds de per-post-doelkeuze in de
 * dialoog zelf afgedwongen en blokkeert niet meer.
 */
export function notConnectedBlockReason(
  platform: string,
  connected: boolean,
): string | null {
  if (connected) return null;
  if (platform === 'facebook') {
    return 'Facebook is nog niet gekoppeld. Koppel Facebook eerst in je instellingen.';
  }
  if (platform === 'linkedin') {
    return 'LinkedIn is nog niet gekoppeld. Koppel LinkedIn eerst in je instellingen.';
  }
  return null;
}
